(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dkt-film-opening"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('dkt-film-opening'))customElements.define('dkt-film-opening',class extends HTMLElement{
  connectedCallback(){
    this.abort?.abort();this.abort=new AbortController();const options={signal:this.abort.signal};
    this.video=this.querySelector('video');this.button=this.querySelector('button');this.motion=matchMedia('(prefers-reduced-motion:reduce)');this.visible=true;this.userPaused=false;this.manual=false;
    this.button.hidden=false;
    this.button.addEventListener('click',()=>{this.userPaused=!this.video.paused;if(!this.userPaused)this.manual=true;this.update();},options);
    this.video.addEventListener('playing',()=>{this.setAttribute('data-playing','');this.sync();},options);
    this.video.addEventListener('pause',()=>this.sync(),options);
    this.video.addEventListener('error',()=>{this.removeAttribute('data-playing');this.button.hidden=true;},options);
    this.motion.addEventListener('change',()=>{this.manual=false;this.update();},options);
    document.addEventListener('visibilitychange',()=>this.update(),options);
    if('IntersectionObserver' in window){this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.update();},{threshold:.05});this.observer.observe(this);}
    this.update();
  }
  update(){const allowed=this.manual||(!this.motion.matches&&!navigator.connection?.saveData);if(!allowed||!this.visible||document.hidden||this.userPaused){this.video.pause();this.sync();return;}if(!this.video.getAttribute('src'))this.video.src=this.video.dataset.src;this.video.muted=true;this.video.play().catch(()=>this.sync());}
  sync(){this.button.querySelector('[data-play]').hidden=!this.video.paused;this.button.querySelector('[data-pause]').hidden=this.video.paused;}
  disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();this.video?.pause();}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dkt-live-location"] && !Shopify.designMode) return;
  try {
    const dktParisClockFormatter = new Intl.DateTimeFormat('fr-FR', {
    timeZone: 'Europe/Paris',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  });

  const updateDktParisClocks = () => {
    const now = new Date();
    const displayedTime = dktParisClockFormatter.format(now);
    document.querySelectorAll('[data-dkt-paris-clock]').forEach((clock) => {
      clock.textContent = displayedTime;
      clock.dateTime = now.toISOString();
    });
  };

  updateDktParisClocks();
  window.setInterval(updateDktParisClocks, 30000);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dkt-page-scene"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('dkt-page-scene'))customElements.define('dkt-page-scene',class extends HTMLElement{
    connectedCallback(){
      this.abort?.abort();this.abort=new AbortController();this.chapter=this.closest('.dkts-scene-chapter');this.pin=this.parentElement;this.copy=this.pin.querySelector('.dktp__wrap');this.video=this.querySelector('video');
      if(!this.chapter||!this.video)return;
      this.motion=matchMedia('(prefers-reduced-motion:reduce)');this.small=matchMedia('(max-width:749px)');
      const options={signal:this.abort.signal};
      this.queue=()=>{if(!this.frame)this.frame=requestAnimationFrame(()=>{this.frame=0;this.update();});};
      ['scroll','resize','pageshow'].forEach(event=>window.addEventListener(event,this.queue,{...options,passive:true}));
      this.motion.addEventListener('change',()=>this.configure(),options);this.small.addEventListener('change',()=>this.configure(),options);
      this.video.addEventListener('loadeddata',()=>{if(this.motion.matches||navigator.connection?.saveData)return;this.chapter.setAttribute('data-scrolling','');this.setAttribute('data-ready','');clearTimeout(this.timeout);this.update();},options);
      this.video.addEventListener('seeked',()=>this.seek(),options);this.video.addEventListener('error',()=>this.staticView(),options);this.configure();
    }
    staticView(){
      this.chapter?.removeAttribute('data-scrolling');this.removeAttribute('data-ready');this.video?.pause();
      ['--scene-progress','--scene-copy','--scene-beat','--scene-retreat'].forEach(key=>this.chapter?.style.removeProperty(key));
      if(this.copy)this.copy.inert=false;clearTimeout(this.timeout);
    }
    configure(){
      this.staticView();
      if(this.motion.matches||navigator.connection?.saveData){this.video.removeAttribute('src');this.video.load();return;}
      this.video.src=this.small.matches?this.video.dataset.mobile:this.video.dataset.desktop;this.video.preload='auto';this.video.load();
      this.timeout=setTimeout(()=>{if(this.video.readyState<2)this.staticView();},12000);
    }
    update(){
      if(!this.chapter.hasAttribute('data-scrolling'))return;
      const top=parseFloat(getComputedStyle(this.pin).top)||0;
      const p=Math.max(0,Math.min(1,(top-this.chapter.getBoundingClientRect().top)/Math.max(1,this.chapter.offsetHeight-this.pin.offsetHeight)));
      const retreat=Math.max(0,Math.min(1,(p-.6)/.4));this.chapter.style.setProperty('--scene-retreat',retreat.toFixed(4));
      const copy=1-Math.min(1,p/.42),beat=Math.max(0,Math.min(1,(p-.5)/.3));
      this.chapter.style.setProperty('--scene-progress',p.toFixed(3));this.chapter.style.setProperty('--scene-copy',copy.toFixed(3));this.chapter.style.setProperty('--scene-beat',beat.toFixed(3));
      this.copy.inert=copy<.05;
      this.target=p*Math.max(0,(this.video.duration||0)-.04);this.seek();
    }
    seek(){if(!this.chapter.hasAttribute('data-scrolling')||this.video.readyState<1||this.video.seeking||!Number.isFinite(this.target))return;if(Math.abs(this.video.currentTime-this.target)>.025)this.video.currentTime=this.target;}
    disconnectedCallback(){this.abort?.abort();cancelAnimationFrame(this.frame);this.staticView();}
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dkt-scroll-stage"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('dkt-scroll-stage'))customElements.define('dkt-scroll-stage',class extends HTMLElement{
    connectedCallback(){
      this.abort?.abort();this.abort=new AbortController();this.story=this.closest('[data-dkt-story]')||this.parentElement;this.video=this.querySelector('video');this.motion=matchMedia('(prefers-reduced-motion:reduce)');this.small=matchMedia('(max-width:749px)');
      const options={signal:this.abort.signal};
      this.queue=()=>{if(!this.frame)this.frame=requestAnimationFrame(()=>{this.frame=0;this.update();});};
      ['scroll','resize','pageshow'].forEach(event=>window.addEventListener(event,this.queue,{...options,passive:true}));
      this.motion.addEventListener('change',()=>this.configure(),options);this.small.addEventListener('change',()=>this.configure(),options);
      this.video?.addEventListener('loadeddata',()=>{this.setAttribute('data-ready','');this.update();},options);this.video?.addEventListener('seeked',()=>this.seek(),options);this.video?.addEventListener('error',()=>this.removeAttribute('data-ready'),options);
      this.observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){this.near=true;this.configure();this.observer.disconnect();}},{rootMargin:'500px'});this.observer.observe(this);this.update();
    }
    configure(){
      if(!this.video)return;
      if(this.motion.matches||navigator.connection?.saveData){this.video.removeAttribute('src');this.video.load();this.removeAttribute('data-ready');this.style.removeProperty('--story-progress');return;}
      if(!this.near)return;
      const source=this.small.matches?this.video.dataset.mobile:this.video.dataset.desktop;
      if(this.video.getAttribute('src')!==source){this.video.src=source;this.video.preload='auto';this.video.load();}
    }
    update(){
      if(this.motion.matches){this.style.removeProperty('--story-progress');return;}
      const rect=this.story.getBoundingClientRect(),top=parseFloat(getComputedStyle(this).top)||83;
      const p=Math.max(0,Math.min(1,(top-rect.top)/Math.max(1,rect.height-this.offsetHeight)));
      this.style.setProperty('--story-progress',p.toFixed(3));
      if(this.video){this.target=p*Math.max(0,(this.video.duration||0)-.04);this.seek();}
    }
    seek(){if(this.motion.matches||!this.hasAttribute('data-ready')||this.video.readyState<1||this.video.seeking||!Number.isFinite(this.target))return;if(Math.abs(this.video.currentTime-this.target)>.03)this.video.currentTime=this.target;}
    disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();cancelAnimationFrame(this.frame);this.video?.pause();}
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dkt-site-cinema"] && !Shopify.designMode) return;
  try {
    (()=>{
    const media=matchMedia('(prefers-reduced-motion:reduce)');
    const seen=new WeakSet(),running=new Set();
    const selectors=['.dktp__section-head','.dktp__offer','.dktp__step','.dktp__sprint','.dktp__proof-copy','.dktp__section > .dktp__wrap > h2','.dkttv__card','.dkt-founder__portrait','.dkt-founder__copy','.dkt-about-pillars article','.dkt-about-quote','#dkt-gift-experience .section-top','#dkt-gift-experience .transform-copy','#dkt-gift-experience .film-feature','#dkt-gift-experience .how li'];
    const observer='IntersectionObserver' in window?new IntersectionObserver(entries=>{
      for(const entry of entries){
        if(!entry.isIntersecting)continue;
        observer.unobserve(entry.target);
        if(media.matches)continue;
        const animation=entry.target.animate([{opacity:.15,transform:'translateY(32px)'},{opacity:1,transform:'none'}],{duration:650,easing:'cubic-bezier(.22,1,.36,1)'});
        running.add(animation);animation.finished.catch(()=>{}).finally(()=>running.delete(animation));
        entry.target.dataset.dktRevealed='true';
      }
    },{threshold:.08}):null;
    function scan(root=document){
      if(!observer)return;
      root.querySelectorAll(selectors.join(',')).forEach(el=>{
        if(seen.has(el))return;seen.add(el);el.dataset.dktReveal='';
        if(el.getBoundingClientRect().top<innerHeight*.92)return;
        observer.observe(el);
      });
    }
    media.addEventListener('change',()=>{if(media.matches){running.forEach(a=>a.cancel());running.clear();}});
    document.addEventListener('shopify:section:load',event=>scan(event.target));
    window.addEventListener('pageshow',()=>scan());
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>scan(),{once:true});else scan();
  })();

  if(!customElements.get('dkt-film-dock'))customElements.define('dkt-film-dock',class extends HTMLElement{
    connectedCallback(){
      this.hero=this.closest('#dkt-gift-experience')?.querySelector('[data-gift-hero-create]');
      this.form=this.closest('#dkt-gift-experience')?.querySelector('#votre-histoire');
      if(!this.hero||!this.form)return;
      this.abort=new AbortController();
      const queue=()=>{if(!this.frame)this.frame=requestAnimationFrame(()=>{this.frame=0;this.update();});};
      ['scroll','resize','pageshow'].forEach(event=>window.addEventListener(event,queue,{passive:true,signal:this.abort.signal}));
      this.update();
    }
    update(){
      this.hidden=!(this.hero.getBoundingClientRect().bottom<80&&this.form.getBoundingClientRect().top>innerHeight*.65);
    }
    disconnectedCallback(){this.abort?.abort();cancelAnimationFrame(this.frame);}
  });

  if(!customElements.get('dkt-card-scene'))customElements.define('dkt-card-scene',class extends HTMLElement{
    connectedCallback(){
      this.abort=new AbortController();this.video=this.querySelector('video');this.card=this.closest('.dktm__card');this.motion=matchMedia('(prefers-reduced-motion:reduce)');this.small=matchMedia('(max-width:749px)');
      const options={signal:this.abort.signal};
      this.queue=()=>{if(!this.frame)this.frame=requestAnimationFrame(()=>{this.frame=0;this.update();});};
      this.observer=new IntersectionObserver(entries=>{for(const e of entries){this.visible=e.isIntersecting;if(this.visible){this.configure();this.update();}}},{rootMargin:'150px'});this.observer.observe(this.card);
      ['scroll','resize','pageshow'].forEach(event=>window.addEventListener(event,this.queue,{...options,passive:true}));
      this.motion.addEventListener('change',()=>this.configure(),options);this.small.addEventListener('change',()=>this.configure(),options);
      this.video.addEventListener('loadeddata',()=>{this.setAttribute('data-ready','');this.update();},options);this.video.addEventListener('seeked',()=>this.seek(),options);this.video.addEventListener('error',()=>this.removeAttribute('data-ready'),options);
    }
    configure(){
      if(this.motion.matches||navigator.connection?.saveData){this.video.removeAttribute('src');this.video.load();this.removeAttribute('data-ready');return;}
      if(!this.visible)return;const source=this.small.matches?this.video.dataset.mobile:this.video.dataset.desktop;
      if(this.video.getAttribute('src')!==source){this.video.src=source;this.video.preload='auto';this.video.load();}
    }
    update(){if(!this.visible||this.motion.matches)return;const r=this.card.getBoundingClientRect();this.target=Math.max(0,Math.min(1,(innerHeight-r.top)/(innerHeight+r.height)))*Math.max(0,(this.video.duration||0)-.04);this.seek();}
    seek(){if(this.motion.matches||!this.hasAttribute('data-ready')||this.video.readyState<1||this.video.seeking||!Number.isFinite(this.target))return;if(Math.abs(this.video.currentTime-this.target)>.03)this.video.currentTime=this.target;}
    disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();cancelAnimationFrame(this.frame);this.video?.pause();}
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dkt-tv-home"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.dkt-tv-home .dkt-tv').forEach((television) => {
    const container = television.closest('.dkt-tv-home');
    const dialog = container?.querySelector('[data-dkt-dialog]');
    if (!dialog || television.dataset.dktReady === 'true') return;
    television.dataset.dktReady = 'true';
    const player = dialog.querySelector('[data-dkt-player]');
    const title = dialog.querySelector('[data-dkt-title]');
    const type = dialog.querySelector('[data-dkt-type]');
    const description = dialog.querySelector('[data-dkt-description]');
    const close = dialog.querySelector('[data-dkt-close]');
    const languageButtons = dialog.querySelectorAll('[data-dkt-lang]');
    let selectedChannel = null;

    const loadLanguage = (language, autoplay = true) => {
      if (!selectedChannel) return;
      const source = language === 'en' ? selectedChannel.dataset.srcEn : selectedChannel.dataset.srcFr;
      const currentTime = Number.isFinite(player.currentTime) ? player.currentTime : 0;
      player.src = source;
      player.load();
      player.addEventListener('loadedmetadata', () => {
        if (currentTime > 0 && currentTime < player.duration) player.currentTime = currentTime;
        if (autoplay) player.play().catch(() => {});
      }, { once: true });
      languageButtons.forEach((button) => {
        const active = button.dataset.dktLang === language;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    };

    television.querySelectorAll('[data-dkt-channel]').forEach((channel) => {
      channel.addEventListener('click', () => {
        selectedChannel = channel;
        title.textContent = channel.dataset.title;
        type.textContent = channel.dataset.type;
        description.textContent = channel.dataset.description;
        dialog.showModal();
        loadLanguage('fr');
      });
    });

    languageButtons.forEach((button) => {
      button.addEventListener('click', () => loadLanguage(button.dataset.dktLang));
    });

    const closeDialog = () => {
      player.pause();
      player.removeAttribute('src');
      player.load();
      selectedChannel = null;
      dialog.close();
    };

    close.addEventListener('click', closeDialog);
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) closeDialog();
    });
    dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      closeDialog();
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dkt-work-style"] && !Shopify.designMode) return;
  try {
    document.addEventListener('play',event=>{if(!event.target.matches?.('.dktw video'))return;document.querySelectorAll('.dktw video').forEach(video=>{if(video!==event.target)video.pause();});},true);
  } catch(e) { console.error(e); }
})();

})();
